import { call, select, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import debug from 'debug';

import * as actions from 'actions/filterAds';
import { getPrevRoute } from 'selectors/routes';
import { getAdFilters } from 'selectors/ads';
import { DEFAULT_PARAMS } from 'constants/BrowseAds';

const log = debug('sagas:adFilters');

export const AD_FILTER_STORAGE_KEY = 'adgen-ad-filters';

export function* isReturningFromAdDetails() {
  const prevRoute = yield select(getPrevRoute);
  return prevRoute && prevRoute.match('/ad/') ? true : false;
}

export function* checkRestoreAdFilters() {
  log('checking if ad filters should be preserved');
  const isAdDetails = yield call(isReturningFromAdDetails);

  if (!isAdDetails) {
    log('resetting ad filters');
    yield put(actions.updateAdFilters(DEFAULT_PARAMS));
    return;
  }

  const currentFilters = yield select(getAdFilters);
  yield put(actions.updateAdFilters(currentFilters));
}

export function* watchAdFilters() {
  yield takeEvery(actions.CHECK_AD_FILTERS, checkRestoreAdFilters);
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/adFilters.js